import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { toast } from "react-toastify";

//import Input from '../../shared/components/FormElements/Input';
import Button from '../../shared/components/FormElements/Button';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';

//import ImageUpload from '../../shared/components/FormElements/ImageUpload'; // For the Image Upload
import FileUpload from '../../shared/components/FormElements/FileUpload'; // For the File Upload

import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './FileForm.css';
// import footer
import Footer from '../../shared/components/UIElements/Footer';

const NewFile = () => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [formState, inputHandler] = useForm(
    {
      image: {
        value: null,
        isValid: false
      }
    },
    false
  );

  const history = useHistory();

  const fileSubmitHandler = async event => {
    event.preventDefault();
    // Here send this to the backend!
    try {
      const formData = new FormData();
      formData.append('image', formState.inputs.image.value);

      await sendRequest(process.env.REACT_APP_BACKEND_URL + '/files/upload', 'POST', formData, {
        Authorization: 'Bearer ' + auth.token
      });
      //history.push('/');
      history.push('/' + auth.userId + '/files');
      toast.success("File uploaded successfully");
    } catch (err) {
      toast.error(err.message || "FIle upload failed.");
    }
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <form className="place-form" onSubmit={fileSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <FileUpload
          id="image"
          onInput={inputHandler}
          //errorText="Please provide a file."
          accept="*/*" /* Added this */
        /> {/* File Upload Component*/}

        <Button type="submit" disabled={!formState.isValid}>
          Upload
        </Button>
      </form>
      {/* Footer */}
      <Footer />
    </React.Fragment>
  );
};

export default NewFile;

